import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import { useInputMask } from "@Shared/@Composables/inputs/useInputMaks";
import TextField from "@Shared/components/form-elements/fields/text-field.vue";
import { computed, defineComponent, ref, toRefs } from "@vue/composition-api";
import { chain, zipObject } from "lodash";
import { useI18n } from "vue-i18n-composable";
import { withValidSin } from "@Shared/@Utils/validation-rules";
import { validationMixin } from "vuelidate";
import { useVuelidate } from "@Shared/@Composables/validations/useVuelidate";
export default defineComponent({
  name: "SinField",
  components: {
    TextField
  },
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    value: {
      withValidSin
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n();
    const {
      buildCanadianSinMask
    } = useInputMask();
    const {
      inputMask
    } = buildCanadianSinMask();
    const {
      v$
    } = useVuelidate();
    const {
      value: propValue
    } = toRefs(props);
    const validSin = computed(() => {
      return !v$.value.$invalid;
    });
    const hiddenSin = ref(false);
    const valueModel = computed({
      get() {
        var _context;
        if (validSin.value && hiddenSin.value) return propValue.value[1] + "XXXXXX";
        return _valuesInstanceProperty(_context = chain(propValue.value)).call(_context).join("").value();
      },
      set(val) {
        var _val$match;
        const splitValue = (_val$match = val.match(/.{1,3}/g)) != null ? _val$match : [];
        const sinValue = zipObject([1, 2, 3], _mapInstanceProperty(splitValue).call(splitValue, formatted => {
          var _formatted$trim;
          return (_formatted$trim = formatted == null ? void 0 : _trimInstanceProperty(formatted).call(formatted)) != null ? _formatted$trim : "";
        }));
        emit("update:value", sinValue);
      }
    });
    const obfuscateSin = computed(() => {
      return /^\d{3}X{3}X{3}$/.test(valueModel.value);
    });
    const handleChange = () => {
      hideSin();
    };
    const showSinIconName = computed(() => {
      return obfuscateSin.value ? "eye" : "eye-slash";
    });
    const hideSin = () => {
      if (validSin.value) {
        hiddenSin.value = true;
      }
    };
    const toggleFullSIN = () => {
      if (props.loading) return;
      if (obfuscateSin.value) {
        emit("show-sin");
        hiddenSin.value = false;
      } else {
        hideSin();
      }
    };
    const showSinToggle = computed(() => {
      return !!valueModel.value && validSin.value;
    });
    const sinTooltipTile = computed(() => {
      return obfuscateSin.value ? t("application.actions.showFullSin") : t("application.actions.hideFullSin");
    });
    const disableInput = computed(() => {
      return props.disabled || props.loading;
    });
    return {
      valueModel,
      inputMask,
      obfuscateSin,
      showSinIconName,
      toggleFullSIN,
      sinTooltipTile,
      showSinToggle,
      disableInput,
      handleChange,
      hiddenSin,
      validSin
    };
  }
});